import { Validation } from "@/data/Validation";

export type EmployeeInOverview = {
    id: number,
    code: string,
    firstName: string,
    lastName: string,
    emailAddress: string | null,
    phoneNumber: string | null,
    creationDate: string,
    latestTimeEntry: EmployeeTimeEntry | null,
};

export type EmployeeDetails = {
    id: number,
    code: string,
    firstName: string,
    lastName: string,
    emailAddress: string | null,
    phoneNumber: string | null,
    creationDate: string, // OffsetDateTime
};

export type EmployeeFormValues = {
    code: string,
    firstName: string,
    lastName: string,
    emailAddress: string | null,
    phoneNumber: string | null,
};

export type EmployeeStatus = {
    code: string,
    firstName: string,
    lastName: string,
    emailAddress: string | null,
    phoneNumber: string | null,
    timeEntries: EmployeeTimeEntry[],
};

export type EmployeeTimeEntry = {
    id: number,
    clockIn: string, // OffsetDateTime
    clockOut: string | null, // OffsetDateTime or null
    breakMinutes: number,
};

export type EmployeeSignInForm = {
    code: string,
};

export type EmployeeTimeEntryFormValues = {
    clockIn: string,
    clockOut: string | null,
    breakMinutes: number,
};

export type EmployeeInReport = {
    id: number,
    firstName: string,
    lastName: string,
    timeEntries: EmployeeTimeEntry[],
};

export const employeeSignInFormValidation: Validation<EmployeeSignInForm> = {
    code: {
        required: true,
        minLength: 4,
        maxLength: 4,
    },
}

export const employeeFormValuesValidation: Validation<EmployeeFormValues> = {
    code: {
        required: true, // Should be `false` when editing new employee
        minLength: 4,
        maxLength: 4,
    },
    firstName: {
        required: true,
        minLength: 1,
        maxLength: 100,
    },
    lastName: {
        required: true,
        minLength: 1,
        maxLength: 100,
    },
    emailAddress: {
        required: false,
        minLength: 1,
        maxLength: 138,
    },
    phoneNumber: {
        required: false,
        minLength: 1,
        maxLength: 48,
    },
}
